import React from 'react'
import axios from '@/utils/myAxios'
import moment from 'moment'
import Cookie from 'js-cookie'
import { Link } from 'react-router-dom'
import {
    Button,
    Pagination,
    Table,
    Modal,
    message,
    Radio,
    InputNumber,
    Input,
    Select,
    Form,
    List,
} from 'antd'
import { tableSummaries, isMobileDevice } from '@/utils/utils'
import { RSA } from '@/utils/rsa'

// 表单数据
const formData = {
    user_id: undefined,
    account: undefined,
    role: undefined,
    new_passwd: undefined,
    union_ids: [],
}

export default class AccountManage extends React.Component {
    state = {
        loading: false, // 是否加载中
        show: false, // 是否显示弹窗
        type: undefined, // 操作类型
        title: undefined, // 弹窗标题
        data: [], // 表格数据
        formData: { ...formData }, // 表单数据
        selectedData: {}, // 选中的表格数据
        accountRole: [
            // 账号角色
            { label: this.props.language['administrator'], value: 0 },
            { label: this.props.language['service'], value: 1 },
        ],
    }

    componentDidMount () {
        this.fetchData()
        if (Cookie.get('unionType') === 'super_union') {
            this.setState({
                accountRole: [
                    ...this.state.accountRole,
                    { label: this.props.language['financing'], value: 4 },
                    { label: this.props.language['managementLayer'], value: 5 },
                ]
            })
        }
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true })
        axios.get('/v1/api/union_select_union_admin').then((res) => {
            this.setState({
                loading: false,
                data: res.data || [],
            })
        })
    }

    /**
     * 删除数据
     */
    handleDelete = (item) => {
        Modal.confirm({
            title: this.props.language['hint'],
            content: this.props.language['deleteConfirm'],
            onOk: () => {
                let path
                if (item.account_type === 0) {
                    // 游戏账号
                    path = item.role === 3 ? `/v1/api/super_union_remove_admin_houtong/${item.user_id}` : `/v1/api/union_remove_union_admin/${item.user_id}`
                } else {
                    // 后台账号
                    path = `/v1/api/union_remove_union_account/${item.user_id}`
                }
                axios
                    .patch(path,
                        {
                            role: item.role,
                        }
                    )
                    .then((res) => {
                        if (res.code === 1) {
                            message.success(
                                this.props.language['deleteSuccessMessage']
                            )
                            this.fetchData()
                        }
                    })
            },
        })
    }

    /**
     * 添加数据
     */
    handleAdd = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                if (this.state.type === 'add') {
                    // 添加
                    if (Cookie.get('unionType') === 'super_union' || Cookie.get('unionType') === 'union') {
                        // 游戏账号
                        axios
                            .get('/v1/api/union_select_user', {
                                params: {
                                    user_id: values.user_id,
                                    all: 1,
                                },
                            })
                            .then((res) => {
                                if (res.code === 1) {
                                    axios
                                        .post(
                                            values.role === 3
                                                ? '/v1/api/super_union_set_admin_houtong'
                                                : '/v1/api/union_set_union_admin',
                                            {
                                                user_id: values.user_id,
                                                union_ids:
                                                    values.role === 3
                                                        ? values.union_ids
                                                        : undefined,
                                                role:
                                                    values.role !== 3
                                                        ? values.role
                                                        : undefined,
                                            }
                                        )
                                        .then((res) => {
                                            if (res.code === 1) {
                                                message.success(
                                                    this.props.language[
                                                    'addSuccessMessage'
                                                    ]
                                                )
                                                this.handleClose()
                                                this.fetchData()
                                            }
                                        })
                                }
                            })
                    } else {
                        // 后台账号
                        axios
                            .post('/v1/api/union_set_union_account',
                                {
                                    account: values.account,
                                    role: values.role,
                                }
                            )
                            .then((res) => {
                                if (res.code === 1) {
                                    message.success(
                                        this.props.language[
                                        'addSuccessMessage'
                                        ]
                                    )
                                    this.handleClose()
                                    this.fetchData()
                                }
                            })
                    }
                } else if (this.state.type === 'changePassword') {
                    // 修改密码
                    Modal.confirm({
                        title: this.props.language["hint"],
                        content: this.props.language["editConfirm"],
                        onOk: () => {
                            axios
                                .get("/v1/api/kpoker_union/time")
                                .then((res) => {
                                    if (res.code === 1) {
                                        axios
                                            .patch("/v1/api/kpoker_union/set_admin_new_password", {
                                                uid: this.state.selectedData.user_id,
                                                new_passwd: RSA.encrypt(values.newPassword + '\b' + res.data),
                                            })
                                            .then((res) => {
                                                if (res.code === 1) {
                                                    this.handleClose()
                                                    this.fetchData()

                                                    Modal.success({
                                                        title: this.props.language[
                                                            'pleaseSaveAccountPassword'
                                                        ],
                                                        content: (
                                                            <div>
                                                                <p>
                                                                    {this.props.language['account']}
                                                                    ：<b>{this.state.selectedData.user_name}</b>
                                                                </p>
                                                                <p>
                                                                    {
                                                                        this.props.language[
                                                                        'newPassword'
                                                                        ]
                                                                    }
                                                                    ：<b>{values.new_passwd}</b>
                                                                </p>
                                                            </div>
                                                        ),
                                                        okText: this.props.language['copyAndSave'],
                                                        onOk: () => {
                                                            this.handleCopy(
                                                                `${this.props.language['account']}：${this.state.selectedData.user_name}\n${this.props.language['password']}：${values.new_passwd}`,
                                                                this.props.language[
                                                                'proxyAccountPassword'
                                                                ]
                                                            )
                                                        },
                                                    })
                                                }
                                            });
                                    }
                                });
                        },
                    });
                }
            }
        })
    }

    /**
     * 显示弹窗
     */
    handleShow = async (type, item) => {
        if (type === 'add') {
            // 新增
            this.setState({
                type,
                show: true,
                title: this.props.language['addAccount'],
            })
        } else if (type === 'changePassword') {
            // 修改密码
            this.setState({
                type,
                show: true,
                title: this.props.language['changePassword'],
                selectedData: { ...item },
            })
        }
    }

    /**
     * 关闭弹窗
     */
    handleClose = () => {
        this.formRef.props.form.resetFields()
        this.setState({ show: false, formData: { ...formData } });
    }

    /**
     * 切换账号类型
     */
    handleChangeAccountType = () => {
        this.formRef.props.form.resetFields()
    }

    /**
     * 复制并保存到本地
     */
    handleCopy = (content, title) => {
        // 复制
        const textarea = document.createElement('textarea')
        textarea.value = content
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        message.success(this.props.language['saveSuccessMessage'])

        // 保存
        const blob = new Blob([content], { type: 'text/plain;charset=utf-8' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `${title}.txt`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
    }

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <Button
                        type="primary"
                        ghost
                        onClick={() => this.handleShow('add')}
                    >
                        {this.props.language['addAccount']}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={false}
                        loading={this.state.loading}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language['addTime']}
                            dataIndex="added_at"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language['accountId']}
                            dataIndex="user_id"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language['accountName']}
                            dataIndex="user_name"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language['accountRole']}
                            dataIndex=""
                            render={(item) =>
                                this.state.accountRole.find(
                                    (item2) => item2.value === item.role
                                ) ?
                                    this.state.accountRole.find(
                                        (item2) => item2.value === item.role
                                    ).label
                                    : ''
                            }
                        />
                        {(Cookie.get('unionType') === 'kpoker_union' || Cookie.get('unionType') === 'direct_union') && (
                            <Table.Column
                                align="center"
                                title={this.props.language['initPassword']}
                                render={(item) => {
                                    return item.init_pass_changed ? this.props.language['initPasswordTips'] : item.init_pass
                                }}
                            />
                        )}
                        <Table.Column
                            align="center"
                            title={this.props.language['operation']}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : 'right'}
                            width={220}
                            render={(item) => (
                                <>
                                    <Button
                                        type="danger"
                                        ghost
                                        onClick={() => this.handleDelete(item)}
                                    >
                                        {this.props.language['delete']}
                                    </Button>
                                    {item.account_type === 1 &&
                                        <Button
                                            type="primary"
                                            className="ml10"
                                            ghost
                                            onClick={() =>
                                                this.handleShow(
                                                    'changePassword',
                                                    item
                                                )
                                            }
                                        >
                                            {this.props.language['changePassword']}
                                        </Button>
                                    }
                                </>
                            )}
                        />
                    </Table>
                </div>

                {/* 表单弹窗 */}
                <FormModal
                    {...this.props}
                    visible={this.state.show}
                    type={this.state.type}
                    title={this.state.title}
                    formData={this.state.formData}
                    accountRole={this.state.accountRole}
                    selectedData={this.state.selectedData}
                    onOk={this.handleAdd}
                    onCancel={this.handleClose}
                    handleChangeAccountType={this.handleChangeAccountType}
                    wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                />
            </div>
        )
    }
}

/**
 * 表单弹窗
 */
const FormModal = Form.create({ name: 'form_model' })(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator, getFieldValue } = this.props.form
            return (
                <Modal
                    maskClosable={false}
                    width={600}
                    title={this.props.title}
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={this.props.onCancel}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: '70vh',
                        overflowY: 'auto',
                    }}
                    footer={
                        <>
                            <Button
                                type="default"
                                onClick={this.props.onCancel}
                            >
                                {this.props.language['cancel']}
                            </Button>
                            <Button
                                type="primary"
                                onClick={this.props.onOk}
                            >
                                {this.props.language['confirm']}
                            </Button>
                        </>
                    }
                >
                    <div className="container-content">
                        {/* 添加 */}
                        {(this.props.type === 'add') && (
                            <Form>
                                {(Cookie.get('unionType') === 'super_union' || Cookie.get('unionType') === 'union') ?
                                    <Form.Item
                                        label={this.props.language['accountId']}
                                    >
                                        {getFieldDecorator('user_id', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language[
                                                        'accountIdVerify'
                                                        ],
                                                },
                                            ],
                                            initialValue:
                                                this.props.formData.user_id,
                                        })(
                                            <InputNumber
                                                precision={0}
                                                min={0}
                                                max={100000000}
                                                placeholder={
                                                    this.props.language[
                                                    'accountIdPlaceholder'
                                                    ]
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    :
                                    <Form.Item
                                        label={this.props.language['backgroundAccount']}
                                    >
                                        {getFieldDecorator('account', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language[
                                                        'backgroundAccountVerify'
                                                        ],
                                                },
                                            ],
                                            initialValue:
                                                this.props.formData.account,
                                        })(
                                            <Input
                                                maxLength={60}
                                                allowClear
                                                placeholder={
                                                    this.props.language[
                                                    'backgroundAccountPlaceholder'
                                                    ]
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                }
                                <Form.Item
                                    label={this.props.language['accountRole']}
                                >
                                    {getFieldDecorator('role', {
                                        rules: [
                                            {
                                                required: true,
                                                message:
                                                    this.props.language[
                                                    'accountRoleVerify'
                                                    ],
                                            },
                                        ],
                                        initialValue: this.props.formData.role,
                                    })(
                                        <Radio.Group >
                                            {this.props.accountRole.map(
                                                (item, index) => (
                                                    <Radio
                                                        key={index}
                                                        value={item.value}
                                                    >
                                                        {item.label}
                                                    </Radio>
                                                )
                                            )}
                                        </Radio.Group>
                                    )}
                                </Form.Item>
                            </Form>
                        )}

                        {/* 修改密码 */}
                        {(this.props.type === 'changePassword') && (
                            <Form>
                                <Form.Item
                                    label={this.props.language['newPassword']}
                                >
                                    {getFieldDecorator('new_passwd', {
                                        rules: [
                                            {
                                                required: true,
                                                message:
                                                    this.props.language[
                                                    'newPasswordVerify'
                                                    ],
                                            },
                                        ],
                                        initialValue:
                                            this.props.formData.new_passwd,
                                    })(
                                        <Input
                                            maxLength={60}
                                            allowClear
                                            placeholder={
                                                this.props.language[
                                                'newPasswordPlaceholder'
                                                ]
                                            }
                                        />
                                    )}
                                </Form.Item>
                            </Form>
                        )}
                    </div>
                </Modal>
            )
        }
    }
)
